// Stash ProductGridItem instances on their card nodes so swatch selection can
// update quickshopInitialVariant (theme only wires this via GridItemSwatches
// after a lazy image fetch).
(function patchProductGridItem() {
  function applyPatch() {
    if (typeof window.ProductGridItem !== 'function' || window.ProductGridItem.__swatchPatched) {
      return typeof window.ProductGridItem === 'function';
    }
    var Original = window.ProductGridItem;
    function PatchedProductGridItem(options) {
      // Empire exposes an ES6 class — must construct with `new`, then return
      // the instance so `new PatchedProductGridItem()` yields it.
      var instance = new Original(options);
      if (options && options.el) {
        options.el.__productGridItem = instance;
      }
      return instance;
    }
    PatchedProductGridItem.prototype = Original.prototype;
    PatchedProductGridItem.__swatchPatched = true;
    window.ProductGridItem = PatchedProductGridItem;
    return true;
  }
  if (!applyPatch()) {
    var tries = 0;
    var poll = setInterval(function() {
      tries += 1;
      if (applyPatch() || tries > 40) clearInterval(poll);
    }, 100);
  }
})();

$(document).ready(function() {
  function removeGalleryPlaceholdersFromSubtree(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.product-gallery').forEach(function(gallery) {
      if (gallery.querySelector('.product-gallery--loaded-image')) {
        gallery.querySelectorAll('.gallery_placeholder').forEach(function(el) {
          el.remove();
        });
      }
    });
  }

  removeGalleryPlaceholdersFromSubtree(document.body);

  var galleryPlaceholderObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type !== 'childList' || !mutation.addedNodes.length) return;
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          removeGalleryPlaceholdersFromSubtree(node);
        }
      });
    });
  });
  galleryPlaceholderObserver.observe(document.body, { childList: true, subtree: true });

  function onElementInserted(containerSelector, elementSelector, callback) {
    var onMutationsObserved = function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          var elements = $(mutation.addedNodes).find(elementSelector);

          elements.each(function() {
              var node = $(this);
              callback(node);
            }
          );
        }
      });
    };

    var target = $(containerSelector)[0];
    var config = { childList: true, subtree: true };
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(onMutationsObserved);
    observer.observe(target, config);
  }

  function calculate_ex_vat_price(inc_vat_price, element) {
    var stripped_price = inc_vat_price.replace(/[^0-9\.]/g, '');

    if (element.data('product-id') === '5463123460252') {
      var price = stripped_price / 1;
    } else {
      var price = stripped_price / 1.2;
    }
    if (element.data('taxfree')) {
      var tax_free_price = element.data('taxfree') / 100;
      pre_tax_price = stripped_price - tax_free_price;
      pre_tax_price = pre_tax_price / 1.2;
      var price = pre_tax_price + tax_free_price;
    }
    return Shopify.formatMoney(price * 100, Shopify.money_format);
  }

  function setup_price(element) {
    if (element.hasClass('atc-product-details-price-discounted') || element.hasClass('price__original')) {
      return;
    }

    if (element.hasClass('pre-money')) {
      update_price(element);
      return;
    }

    var inc_vat_price = element.text(),
      ex_vat_price = calculate_ex_vat_price(inc_vat_price, element),
      additional_classes = '';
    element.addClass('pre-money').addClass('hidden');

    $('<div class="exemptify_clone ' + additional_classes + '"></div>').insertAfter(element);

    var container = element.nextAll('.exemptify_clone:first');

    container.append('<span class="exemptify_inc_vat">' + inc_vat_price + ' (Inc VAT)</span><br />');
    container.append('<span class="exemptify_ex_vat" style="color:#727272;font-size: max(0.8em, 0.875rem);font-weight: normal;">' + ex_vat_price.replace('$', currencySymbol) + ' (Ex VAT)</span><br />');
  }

  function update_price(element) {
    if (element.hasClass('atc-product-details-price-discounted')) {
      return;
    }
    if (!element.hasClass('pre-money')) {
      setup_price(element);
      return;
    }
    var container = element.nextAll('.exemptify_clone:first'),
      inc_vat_price = element.text(),
      ex_vat_price = calculate_ex_vat_price(inc_vat_price, element).replace('$', currencySymbol);

    container.find('.exemptify_inc_vat').text(inc_vat_price + ' (Inc VAT)');
    container.find('.exemptify_ex_vat').text(ex_vat_price + ' (Ex VAT)');
  }

  function observePriceChanges(element) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          update_price($(mutation.target).closest('.money'));
        }
      });
    });

    var config = { characterData: true, childList: true, subtree: true };
    observer.observe(element[0], config);
  }

  $('body').find('.money').each(function() {
      setup_price($(this));
      observePriceChanges($(this));
    }
  );

  onElementInserted('body', '.money', function(element) {
      setup_price(element);
      observePriceChanges(element);
    }
  );

  // Listen for changes on the variant selector
  $('body').on('change', 'select[data-variant-option]', function() {
    setTimeout(function() {
      $('.money').each(function() {
          update_price($(this));
        }
      );
    }, 100); // Adjust the timeout as needed
  });

  $('[data-cartitem-quantity]').change(function() {
    setTimeout(function() {
      $('.cartitems--list').find('.money').each(function() {
          setup_price($(this));
          observePriceChanges($(this));
        }
      );
    }, 3000);
  });

  // Product-card colour swatches: keep ATC variant, price, and image in sync
  // when a swatch is selected (PLP + Nosto cards that reuse theme markup).
  function formatCardMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var format = (window.theme && theme.moneyFormat)
        || (typeof Shopify.money_format !== 'undefined' && Shopify.money_format)
        || '£{{amount}}';
      return Shopify.formatMoney(cents, format);
    }
    var value = (Number(cents) / 100).toFixed(2);
    return '£' + value;
  }

  function applyProductCardSwatch(input) {
    if (!input || !input.checked) return;

    var card = input.closest('[data-product-item]');
    if (!card) return;

    var variantId = input.getAttribute('data-variant-id');
    var variantPrice = input.getAttribute('data-variant-price');
    var variantCompare = input.getAttribute('data-variant-compare');
    var variantImage = input.getAttribute('data-variant-image');
    var variantPriceFormatted = input.getAttribute('data-variant-price-formatted');
    var variantCompareFormatted = input.getAttribute('data-variant-compare-formatted');

    if (variantId) {
      var atcButton = card.querySelector('[data-quick-buy], [data-quickshop-slim]');
      if (atcButton) {
        atcButton.setAttribute('data-variant-id', variantId);
      }
      if (card.__productGridItem) {
        card.__productGridItem.quickshopInitialVariant = variantId;
      }
    }

    if (variantImage) {
      var primaryImage = card.querySelector('.productitem--image-primary');
      if (primaryImage) {
        if (primaryImage.tagName === 'IMG') {
          primaryImage.src = variantImage;
          if (primaryImage.hasAttribute('srcset')) {
            primaryImage.removeAttribute('srcset');
          }
        } else {
          primaryImage.setAttribute('data-src', variantImage);
          primaryImage.style.backgroundImage = 'url("' + variantImage + '")';
        }
      }
      var alternateImage = card.querySelector('.productitem--image-alternate');
      if (alternateImage) {
        alternateImage.style.visibility = 'hidden';
      }
      // Kick the theme GridItemSwatches image injector (loads on first hover)
      try {
        card.dispatchEvent(new Event('mouseover', { bubbles: true }));
      } catch (e) { /* ignore */ }
    }

    var priceEl = card.querySelector('[data-price]');
    if (priceEl) {
      var nextPrice = variantPriceFormatted;
      if (!nextPrice && variantPrice) {
        nextPrice = formatCardMoney(variantPrice);
      }
      if (nextPrice) {
        // Strip any "from" range prefix once a concrete variant is chosen
        var priceContainer = card.querySelector('[data-price-container]');
        if (priceContainer) {
          priceContainer.classList.remove('price__current--range');
        }
        priceEl.textContent = nextPrice;
      }
    }

    var compareEl = card.querySelector('[data-price-compare]');
    var compareContainer = card.querySelector('[data-price-compare-container]');
    if (compareEl && compareContainer) {
      var nextCompare = variantCompareFormatted;
      if (!nextCompare && variantCompare) {
        nextCompare = formatCardMoney(variantCompare);
      }
      if (nextCompare) {
        compareEl.textContent = nextCompare;
        compareContainer.classList.add('visible');
      } else if (
        input.hasAttribute('data-variant-compare') ||
        input.hasAttribute('data-variant-compare-formatted') ||
        input.hasAttribute('data-variant-price-formatted')
      ) {
        compareContainer.classList.remove('visible');
      }
    }

    var pageLinks = card.querySelectorAll('[data-product-page-link]');
    pageLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      if (!href || !variantId) return;
      var base = href.split('?')[0];
      link.setAttribute('href', base + '?variant=' + variantId);
    });
  }

  $('body').on('change', '.productitem--swatches-input', function() {
    applyProductCardSwatch(this);
  });

  // Also apply when the theme GridItemSwatches toggles selection via click
  // (change may not fire when deselecting; selection still fires change).
  $('body').on('click', '.productitem--swatches-input', function() {
    var input = this;
    setTimeout(function() {
      if (input.checked) {
        applyProductCardSwatch(input);
      }
    }, 0);
  });

});

(function dataSheetsVariantSwitching() {
  function applyVariant(scope, variantId) {
    var groups = scope.querySelectorAll('[data-sds-variant]');
    if (!groups.length) return;

    groups.forEach(function(group) {
      var isSelected = variantId !== null && Number(group.dataset.sdsVariant) === variantId;
      group.setAttribute('data-sds-selected', isSelected ? 'true' : 'false');
    });
  }

  document.addEventListener('variant-change', function(event) {
    var selection = event.target;
    if (!selection || !selection.matches || !selection.matches('[data-variant-selection]')) return;

    var variant = event.detail && event.detail.variant;
    var scope = selection.closest('[data-product-details]') || document;

    applyVariant(scope, variant ? variant.id : null);
  }, true);
})();
